import { HttpAxiosRequest } from "./httpAxiosRequest";

export type MercadoPagoReturnVerificacionDTO = {
    estado: "approved" | "pending" | "rejected" | "processing";
    detalleEstado?: string | null;
    idOrden: string; // Guid
    numeroOrden?: number | null; // long
    transaccionEfectuada: boolean;
    mensaje?: string | null;
};

export const HttpMercadoPagoReturn = {
    getEndpoint: (url: string) => `/mercadopago/return${url}`,

    verificar: (params: {
        uniIdOrden: string;
        uniIdPagoProveedorTransaccion: string;
        payment_id?: string | null;
        collection_id?: string | null;
    }): Promise<MercadoPagoReturnVerificacionDTO> => {
        return HttpAxiosRequest.getWithQueryParamsSerializer(
            HttpMercadoPagoReturn.getEndpoint("/verificar"),
            params,
        );
    },
};
